import axios from "axios";
import { getAuthHeaders } from "../helpers";

/**
 * @function getPromoCodeList
 * @param pageNo
 * @description This function  will fetch the promo codes list.
 */
export const getPromoCodeList = pageNo => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_promo_codes?page=${pageNo}&perpage=10`;

  return axios.get(url, {
    headers: getAuthHeaders()
  });
};

/**
 * @function addPromoCode
 * @desc  add Promo code.
 */

export const addPromoCode = data => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_promo_codes`;
  return axios.post(url, data, {
    headers: getAuthHeaders()
  });
};

/**
 * @function updatePromoCode
 * @desc  add Promo code.
 */

export const updatePromoCode = (data, id) => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_promo_codes/${id}`;
  return axios.put(url, data, {
    headers: getAuthHeaders()
  });
};

/**
 * @function deletePromoCode
 * @desc  delete Promo code.
 */

export const deletePromoCode = id => {
  const url = `${process.env.REACT_APP_SERVER_URL}/admin/billing_promo_codes/${id}`;
  return axios.delete(url, {
    headers: getAuthHeaders()
  });
};
